module.exports = __webpack_public_path__ + "assets/e8d57658218f971dde8cb6c52897d1e2.svg";